import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SearchInput = ({
    search_query,
    is_predictions_list_indicator_visible,
    onFocus,
    onBlur,
    onChange,
    onKeyDown,
}) => {
    const { t } = useTranslation('customer.address.door-dash-drive');

    return (
        <div
            data-icon-before
            data-icon-after
            className="m2g-customer-address-picker m2g-input-container"
        >
            <span
                className="m2g-icon m2g-icon--search m2g-customer-address-picker-search-icon"
                data-before
            />
            <input
                className="m2g-input m2g-customer-address-picker-input m2g-form-element--full-width"
                data-field="search_query"
                placeholder={t('find_address_placeholder')}
                value={search_query}
                type="text"
                onClick={event => {
                    event.target.select();
                }}
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
            {is_predictions_list_indicator_visible && (
                <span
                    className="m2g-icon m2g-icon--chevron-down m2g-customer-address-picker-chevron-icon"
                    data-after
                />
            )}
        </div>
    );
};

SearchInput.propTypes = {
    search_query: PropTypes.string,
    is_predictions_list_indicator_visible: PropTypes.bool.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

SearchInput.defaultProps = {
    search_query: '',
};

export default SearchInput;
